/**
 * Auteurs du blog. `id` est utilisé dans le champ `author` des articles.
 *
 * `image` est facultatif : sans photo, les composants affichent un monogramme
 * (voir src/blog/components/Avatar.js).
 */
const authors = {
  jimmy: {
    id: "jimmy",
    name: "Jimmy Inthalangsy",
    // « Journal » : terme libre en droit français (seul le titre de journaliste professionnel est encadré).
    role: "Fondateur du journal IA Besançon & développeur IA",
    bio:
      "Développeur IA indépendant depuis une dizaine d'années, il a fondé IA Besançon, un journal à but non lucratif, pour raconter — par passion, et pour la transmettre — ce que le bassin bisontin invente en intelligence artificielle et en tech.",
    image: null,
    links: {
      linkedin: "https://www.linkedin.com/in/jimmy-inthalangsy-37a4b229a/",
      github: "https://github.com/jimmindev",
      email: "jimmy.inthalangsy@gmail.com",
    },
  },
};

export default authors;

export const getAuthor = id => authors[id] || null;
